import React, { useMemo } from 'react'
import { ApolloProvider } from '@apollo/client'

import { useAuth } from '../OIDCProvider'
import getStudentClientOIDC from '../../../lib/clients/getStudentClientOIDC'

type StudentApolloProviderProps = {
  /** Children React Components, most likely the App component */
  children: React.ReactNode
}

const StudentApolloProvider = ({ children }: StudentApolloProviderProps) => {
  const { isAuthenticated, getTokenSilently } = useAuth()

  const client = useMemo(
    () => getStudentClientOIDC(getTokenSilently, isAuthenticated),
    [isAuthenticated, getTokenSilently]
  )

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default StudentApolloProvider
